import React from 'react';

import { Title, Button, ButtonsGroup } from 'components/commons';
import trafficIcon from 'assets/svg/traffic-signal.svg';

type CantRenewLayoutProps = {
    onOk(): void;
}

const CantRenewLayout: React.FC<CantRenewLayoutProps> = ({ onOk }) => (
    <div className="message-box-container">
        <div className="inner">
            <div className="screen">
                <div className="message-box">
                    <img className="icon" src={trafficIcon} />

                    <Title> Aguenta esperar <br className="d-block d-sm-none" />um pouquinho?</Title>

                    <p className="text">
                        Quando você estiver mais próximo <br className="d-block d-sm-none" />
                        da quitação do empréstimo já vai <br className="d-block d-sm-none" />
                        poder pedir novamente.
                    </p>

                    <p className="text">
                    Fique tranquilo, avisaremos <br className="d-block" />
                    quando chegar a hora!
                    </p>
                </div>

                <ButtonsGroup align="left">
                    <Button label="finalizar" onClick={onOk} />
                </ButtonsGroup>
            </div>
        </div>
    </div>
);

export default CantRenewLayout;
